import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicantService } from '@core/services/auth-user/applicant.service';
import { SpinnerService } from '@core/services/spinner.service';
import { TokenService } from '@core/services/token/token.service';
import { ClientUserService } from '@features/client-user/client-user.service';
import { DashboardsService } from '@features/dashboards/dashboards.service';
import { DeepLinkingService } from '../../services/deep-linking.service';
import { PortalDeterminationService } from '../../services/portal-determination.service';

@Component({
    selector: 'yc-sso-redirect',
    template: '',
    standalone: false
})
export class SSORedirectComponent {
  constructor (
    tokenService: TokenService,
    dashboardService: DashboardsService,
    clientUserService: ClientUserService,
    applicantService: ApplicantService,
    portalDetService: PortalDeterminationService,
    deepLinkingService: DeepLinkingService,
    spinnerService: SpinnerService,
    activatedRoute: ActivatedRoute
  ) {
    const clientId = activatedRoute.snapshot.queryParams.clientId;
    const nextRoute = portalDetService.isManager ?
      dashboardService.homeRoute :
      '/apply/applications';
    // don't exchange SSO if already logged in
    (async () => {
      if (!tokenService.getIsLoggedIn()) {
        spinnerService.startSpinner();
        // if we are on this comp we kick off the exchange (the exchange will redirect if on the wrong subdomain)
        await tokenService.ssoExchange(
          async () => {
            if (portalDetService.isManager) {
              return clientUserService.getUser(true);
            } else {
              return applicantService.getApplicant(true);
            }
          },
          clientId ? +clientId : null
        );
        spinnerService.stopSpinner();
      }
      deepLinkingService.attemptDeepLink(nextRoute);
    })();
  }
}
